export const SITE = {
  name: "Kensmarc Electric",
  owner: "Marcos Hernandez",
  tagline: "Residential • Commercial • Industrial",
  license: "California C-10 Electrical Contractor",
  domain: "kensmarcelectric.com",
  url: "https://kensmarcelectric.com",
  email: "kensmarc@gmail.com",
  emailHref: "mailto:kensmarc@gmail.com",
  yelpUrl: "https://www.yelp.com/biz/kensmarc-electric-west-covina",
  googleUrl: "https://share.google/TeruAtG9hwZzBKvVh",
  googleReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJfwRbm_gpw4ARG_DyhWXHw4U&source=g.page.m._&laa=merchant-review-solicitation",
  tiktokUrl: "https://www.tiktok.com/@kensmarcelectric",
  phonePrimary: { display: "(626) 539-5844", tel: "tel:6265395844" },
  phoneSecondary: { display: "(818) 310-3235", tel: "tel:8183103235" },
  serviceZip: "91702",
  radiusMiles: 25,
  county: "Los Angeles County, California",
  countyShort: "Los Angeles County, CA",
  serviceAreaShort: "91702 & surrounding areas · Los Angeles County, CA",
  serviceAreaBlurb:
    "Based near the 91702 area, Kensmarc Electric serves customers throughout the surrounding communities and handles projects across Los Angeles County depending on location and project requirements.",
  serviceAreaLine:
    "Serving customers within approximately 25 miles of 91702 and select areas throughout Los Angeles County.",
  credentials: "Licensed · Insured · C-10",
  hours: {
    display: [
      { days: "Monday – Friday", time: "6:00 AM – 6:00 PM" },
      { days: "Saturday – Sunday", time: "Closed" },
    ],
    short: "Mon–Fri: 6:00 AM–6:00 PM · Sat–Sun: Closed",
  },
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Our Work", to: "/our-work" },
  { label: "CCTV & Security", to: "/cctv-security" },
  { label: "About", to: "/about" },
  { label: "Reviews", to: "/reviews" },
  { label: "Service Area", to: "/service-area" },
  { label: "Contact", to: "/contact" },
];

export const PROPERTY_TYPES = ["Residential", "Commercial", "Industrial", "Other"];

export const CONTACT_METHODS = ["Phone", "Text Message", "Email"];
